import React, { Component } from "react";
import TextArea from "antd/lib/input/TextArea";
import { Drawer, Form, Button, InputNumber, Row, Col, Select, Modal } from "antd";
import { connect } from "dva";
import { hideJiraWidget, showJiraWidget } from "@/utils/utils";
import MarginFeedbackAlert from "@/components/MarginFeedbackAlert";

const { Option } = Select;

class QuotesForm extends Component {
  state = {
    isMobile: false,
    visible: false,
    originalDealerPrice: null,
    originalTransporterPrice: null,
    currentDealerPrice: null,
    currentTransporterPrice: null,
    isLowPriceMargin: false,
    displayLowPriceMarginModal: false,
  };

  quotesEditFormRef = React.createRef();
  lowPriceMarginFormRef = React.createRef();

  componentDidMount = () => {
    let isMobile = window.innerWidth <= 768;
    this.setState({
      isMobile,
    });
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
    hideJiraWidget();
  };

  onClose = () => {
    this.setState({
      visible: false,
      isLowPriceMargin: false,
      displayLowPriceMarginModal: false,
      currentDealerPrice: null,
      currentTransporterPrice: null,
    });
    showJiraWidget();
  };

  onSubmit = () => {
    const { dispatch } = this.props;
    const {
      originalDealerPrice,
      originalTransporterPrice,
      currentDealerPrice,
      currentTransporterPrice,
      isLowPriceMargin,
    } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleId = urlParams.get("vehicleId");
    const quoteId = urlParams.get("quoteId");
    this.quotesEditFormRef.current.validateFields().then(result => {
      result.dealerPriceReason = result.dealerPriceReason ? result.dealerPriceReason : null;
      result.transporterPriceReason = result.transporterPriceReason ? result.transporterPriceReason : null;

      const pricesChanged =
        currentDealerPrice !== originalDealerPrice || currentTransporterPrice !== originalTransporterPrice;

      if (isLowPriceMargin && pricesChanged) {
        const lowPriceMarginReason = this?.lowPriceMarginFormRef?.current?.getFieldValue("lowPriceMarginReason");
        const lowPriceMarginReasonEntered =
          lowPriceMarginReason !== null && lowPriceMarginReason !== undefined && lowPriceMarginReason !== "";

        if (!lowPriceMarginReasonEntered) {
          this.setState({
            displayLowPriceMarginModal: true,
          });

          return;
        }

        result.lowPriceMarginReason = lowPriceMarginReason;
      }

      if (quoteId) {
        dispatch({
          type: "quotesView/adminEditQuoteByQuoteId",
          quoteId,
          payload: { ...result, quoteId },
        }).then(() => {
          this.onClose();
        });
      } else {
        dispatch({
          type: "quotesView/adminEditQuote",
          vehicleId,
          payload: { ...result, vehicleId },
        }).then(() => {
          this.onClose();
        });
      }
    });
  };

  fillFormFields = visible => {
    const { quoteId, dealerPrice, transporterPrice, dealerPriceReason, transporterPriceReason } = this.props;

    if (visible) {
      this.quotesEditFormRef.current.setFieldsValue({
        quoteId: quoteId,
        dealerPrice: dealerPrice,
        transporterPrice: transporterPrice,
        dealerPriceReason: dealerPriceReason ? dealerPriceReason : 0,
        transporterPriceReason: transporterPriceReason ? transporterPriceReason : 0,
      });

      this.setState({
        originalDealerPrice: dealerPrice,
        currentDealerPrice: dealerPrice,
        originalTransporterPrice: transporterPrice,
        currentTransporterPrice: transporterPrice,
      });
    }
  };

  render() {
    const { submitting, configPerm } = this.props;
    const {
      isMobile,
      visible,
      originalDealerPrice,
      currentDealerPrice,
      originalTransporterPrice,
      currentTransporterPrice,
      isLowPriceMargin,
      displayLowPriceMarginModal,
    } = this.state;

    return (
      <div>
        {configPerm["CoreService.Quotes.Edit"] && (
          <Button
            type="primary"
            onClick={this.showDrawer}
            style={{ margin: "8px 0" }}
            disabled={!configPerm["CoreService.Quotes.Edit"]}
          >
            Edit Quote
          </Button>
        )}
        <Drawer
          title="Review and Submit Quote"
          width={isMobile ? "80%" : "40%"}
          onClose={this.onClose}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
          afterVisibleChange={visible => this.fillFormFields(visible)}
          footer={
            <Row align="space-between">
              <Col flex={1}>
                <MarginFeedbackAlert
                  dealerPrice={currentDealerPrice}
                  transporterPrice={currentTransporterPrice}
                  lowMarginAlertCallback={() => {
                    if (!isLowPriceMargin) {
                      this.setState({
                        isLowPriceMargin: true,
                      });
                    }
                  }}
                  goodMarginAlertCallback={() => {
                    if (isLowPriceMargin) {
                      this.setState({
                        isLowPriceMargin: false,
                      });
                    }
                  }}
                />
              </Col>
              <Col flex={3}>
                <div style={{ textAlign: "right" }}>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                  <Button type="primary" onClick={this.onSubmit} loading={submitting}>
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          }
        >
          <Form ref={this.quotesEditFormRef} layout="vertical">
            <Form.Item name="dealerPrice" label="Dealer Price">
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                parser={value => value.replace(/\$\s?|(,*)/g, "")}
                value={this.state.currentDealerPrice}
                onChange={currentDealerPrice => this.setState({ currentDealerPrice })}
              />
            </Form.Item>
            <Form.Item name="transporterPrice" label="Transporter Price">
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                parser={value => value.replace(/\$\s?|(,*)/g, "")}
                value={this.state.currentTransporterPrice}
                onChange={currentTransporterPrice => this.setState({ currentTransporterPrice })}
              />
            </Form.Item>
            <Row gutter={16}>
              <Col lg={12}>
                <Form.Item
                  name="dealerPriceReason"
                  label="Dealer Price Reason"
                  rules={[
                    {
                      validator: (_, value) =>
                        value ||
                        (!value &&
                          this?.quotesEditFormRef?.current?.getFieldValue("dealerPrice") === originalDealerPrice)
                          ? Promise.resolve()
                          : Promise.reject("Please enter price change reason."),
                    },
                  ]}
                >
                  <Select
                    getPopupContainer={trigger => trigger.parentElement}
                    disabled={currentDealerPrice === originalDealerPrice}
                  >
                    <Option style={{ display: "none" }} value={0}>
                      No Reason
                    </Option>{" "}
                    {/* Can only be 0 in case of legacy rows. These are null in the db. Shouldn't let any edits to these rows stay as null. */}
                    <Option value={1}>Full Price</Option>
                    <Option value={2}>Decreased Price - Vehicle Not Ready</Option>
                    <Option value={3}>Decreased Price - Other</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  name="transporterPriceReason"
                  label="Transporter Price Reason"
                  rules={[
                    {
                      validator: (_, value) =>
                        value ||
                        (!value &&
                          this?.quotesEditFormRef?.current?.getFieldValue("transporterPrice") ===
                            originalTransporterPrice)
                          ? Promise.resolve()
                          : Promise.reject("Please enter price change reason."),
                    },
                  ]}
                >
                  <Select
                    getPopupContainer={trigger => trigger.parentElement}
                    disabled={currentTransporterPrice === originalTransporterPrice}
                  >
                    <Option style={{ display: "none" }} value={0}>
                      No Reason
                    </Option>{" "}
                    {/* Can only be 0 in case of legacy rows. These are null in the db. Shouldn't let any edits to these rows stay as null. */}
                    <Option value={1}>Full Price</Option>
                    <Option value={2}>Decreased Price - Gate Pass</Option>
                    <Option value={3}>Decreased Price - Incorrect Address</Option>
                    <Option value={4}>Decreased Price - Vehicle Not Ready</Option>
                    <Option value={5}>Decreased Price - Other</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="quoteId">
              <InputNumber style={{ display: "none" }} />
            </Form.Item>
          </Form>
        </Drawer>
        <Modal
          title="Low Pricing Margin"
          visible={displayLowPriceMarginModal}
          onOk={this.onSubmit}
          onCancel={() => {
            this.setState({
              displayLowPriceMarginModal: false,
            });
          }}
          confirmLoading={submitting}
          afterClose={() => {
            this.lowPriceMarginFormRef.current.resetFields();
          }}
        >
          <div style={{ marginBottom: 32 }}>Pricing margin is less than 15%. Please enter reason for low margin.</div>
          <Form ref={this.lowPriceMarginFormRef} layout="vertical">
            <Form.Item name="lowPriceMarginReason" label="Reason for Low Margin" rules={[{ required: true }]}>
              <TextArea rows={4} />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default connect(({ loading, quotesView, configs }) => ({
  quotesView,
  submitting: loading.effects["quotesView/adminEditQuote"],
  configPerm: configs.configPerm,
}))(QuotesForm);
